export default {
  totalProjects: 0,
  totalKeywords: 0,
  totalLinks: 0,
  totalReports: 0,
  totalProxies: 0,
  totalUsers: 0,
  engines: null,
  selectEngines: [
    {
      id: 0,
      name: 'google.com',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-US'
    },
    {
      id: 1,
      name: 'google.co.il',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 2,
      name: 'google.co.il',
      device_css: 'icon-screen-smartphone',
      country_css: 'fa bfh-flag-IL'
    },
    {
      id: 3,
      name: 'google.co.uk',
      device_css: 'icon-screen-desktop',
      country_css: 'fa bfh-flag-GB'
    }
  ],
  userRoles: {},
  selectUserRoles: [
    {
      id: 0,
      name: 'client'
    },
    {
      id: 1,
      name: 'member'
    },
    {
      id: 2,
      name: 'admin'
    }
  ],
  reports: null,
  selectReports: [
    {
      id: 0,
      name: 'Competitor'
    },
    {
      id: 1,
      name: 'Ranking'
    },
    {
      id: 2,
      name: 'Pages Performance'
    },
    {
      id: 3,
      name: 'Competing URLs'
    },
    {
      id: 4,
      name: 'Subfinder'
    },
    {
      id: 5,
      name: 'Potential Traffic'
    },
    {
      id: 6,
      name: 'Visibility'
    },
    {
      id: 7,
      name: 'Losers'
    },
    {
      id: 8,
      name: 'Winners'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/metadata/state.js